// Shared visual primitives for BarChart bodies (EnumBarBody, HistogramBody,
// the bar variant of MapDistributionBody, MapKeyBarBody).
//
// Every bar chart in the app uses the same default fill, the same tick
// font, the same hover-cursor wash, and the same tooltip card. Hoisting
// these here means a single edit changes "the look of a bar chart"
// instead of four parallel ones drifting apart over time.
//
// Margin is parameterized because categorical bars with angled x-labels
// need more bottom room than a numeric x-axis with horizontal ticks.

import React from 'react';

export const BAR_FILL = '#8884d8';
export const BAR_TICK = { fontSize: 13 } as const;
export const BAR_TOOLTIP_CURSOR = { fill: BAR_FILL, fillOpacity: 0.15 };
export const BAR_CATEGORY_GAP = '35%';

export type BarChartLayout = 'categorical-angled' | 'numeric';

export function barChartMargin(fullscreen: boolean, layout: BarChartLayout) {
  const bottom = layout === 'categorical-angled'
    ? (fullscreen ? 60 : 40)
    : (fullscreen ? 50 : 30);
  return { top: 10, right: fullscreen ? 30 : 20, left: -10, bottom };
}

export const BarTooltipCard: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="bg-white border border-gray-200 rounded shadow-md px-2 py-1 text-sm">
    {children}
  </div>
);
